import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap, of, catchError, throwError } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { UrlProviderService, EndPoints } from 'src/app/service/urlprovider.service';

@Injectable({
    providedIn: 'root'
})
export class StudentServiceListsService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    getStudentServiceListCount(payload: any): Observable<any> {
        return this.post<any>(EndPoints.studentServiceLists_GetStudentServiceListCount, false, '', {
            chosenRegions: payload.chosenRegions,
            chosenCounties: payload.chosenCounties,
            chosenSchoolDistricts: payload.chosenSchoolDistricts,
            chosenSchools: payload.chosenSchools,
            performancePeriod: payload.performancePeriod,

            expiredEligibility: payload.expiredEligibility,
            expiredQAD: payload.expiredQAD,
            emptyActiveServices: payload.emptyActiveServices,

            grades: payload.grades,
            partyServices: payload.partyServices,
            enrollmentPeriods: payload.enrollmentPeriods,
            serviceCategories: payload.serviceCategories
        }).pipe(
            switchMap((result) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['regions', 'counties', 'schoolDistricts', 'schools'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    getStudentsByPartyService(payload: any): Observable<any> {
        return this.post<any>(EndPoints.studentServiceLists_GetStudentsByPartyService, false, '', {
            chosenRegions: payload.chosenRegions,
            chosenCounties: payload.chosenCounties,
            chosenSchoolDistricts: payload.chosenSchoolDistricts,
            chosenSchools: payload.chosenSchools,
            performancePeriod: payload.performancePeriod,

            expiredEligibility: payload.expiredEligibility,
            expiredQAD: payload.expiredQAD,

            grades: payload.grades,
            partyServices: payload.partyServices,
            enrollmentPeriods: payload.enrollmentPeriods,
            serviceCategories: payload.serviceCategories
        }).pipe(
            switchMap((result) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['students'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }
    getServiceInfoReportByPartyService(partyServiceId: any): Observable<any> {
        return this.get<any>(EndPoints.serviceDelivery_Report, null, partyServiceId);
    }
}
        